<template>
    
</template>

<script>
    export default {
        name: "GitlabRedirectPage",
        mounted: async function() {
            var me = this;
            console.log("GitlabRedirectPage");
            const parser = new URLSearchParams(window.location.search);
            // console.log(parser.getAll())
            var getToken = await this.$http.post("https://gitlab.msastudy.io/oauth/token", {
                "client_id": "c9a14e66daca5ea1f2851ef12fb81f5493f326c026f3e048d135dd4b86bc9691",
                "client_secret": "fdbdac8c30804a5d66c98b77bb06f338873e0ff8cd066af30075d5b6ee2e1d82",
                "code": parser.get("code"),
                "grant_type": "authorization_code",
                "redirect_uri": "https://www.msastudy.io/oauth/gitlab"
            });
            console.log(getToken.data)
            var accessToken = getToken.data.access_token;
            var getUsers = await this.$http.get(`https://gitlab.msastudy.io/api/v4/user?access_token=${accessToken}`);
            getUsers["data"]["accessToken"] = accessToken;
            await this.postMessage(getUsers);
            window.close();
        },
        methods: {
            async postMessage(getUsers) {
                return new Promise(function (resolve) {
                    window.opener.postMessage({message: "gitlab-login", data: JSON.parse(JSON.stringify(getUsers))},"*");
                    resolve();
                })

            }
        }
        // mounted() {
        //     window.href = window.location.host
        // }
    }
</script>

<style scoped>

</style>